// extracted by mini-css-extract-plugin
export default {"item":"cart-item-registration-total-module--item--xDL-B","number":"cart-item-registration-total-module--number--3VCgw","price":"cart-item-registration-total-module--price--3hiqP"};